import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { HtmlEditorComponent } from '@components/html-editor/html-editor.component';

@UntilDestroy()
@Component({
	selector: 'app-html-mini-editor',
	templateUrl: '../html-editor.component.html',
	standalone: false,
})
export class HtmlMiniEditorComponent
	extends HtmlEditorComponent
	implements OnInit
{
	itemsToRemove = ['tagsTableButton', 'pagebreak', 'documentSetupButton'];

	ngOnInit(): void {
		super.ngOnInit();
		this.tinyMCEInit = {
			...this.tinyMCEInit,
			toolbar: this.tinyMCEInit.toolbar
				.map((t) => {
					return {
						...t,
						items: t.items.filter((item) => !this.itemsToRemove.includes(item)),
					};
				})
				.filter((t) => t.items.length > 0),
		};
	}

	updateContent(document: string) {
		this.debouncer.next(document);
	}
}
